<template>
  <div class="col-lg-12">
    <div class="main-card mb-3 card">
      <div class="card-body">
        <h5 class="card-title">기관관리</h5>
        <div class="sub_title">캠퍼스 관리</div>

        <div class="input-group" style="width: 50%; display: none">
          <span class="input-group-text" id="basic-addon1"
            ><i class="bi bi-search"></i
          ></span>
          <input
            type="text"
            class="form-control"
            placeholder="아이디, 이메일, 이름으로 검색하세요"
            aria-describedby="basic-addon1"
          />
        </div>
        <div class="col-lg-6 offset-lg-3 search_box">
          <table class="table">
            <tr>
              <td>선택검색</td>
              <td>
                <div class="input-group mb-12">
                  <div class="input-group-prepend">
                    <select
                      class="custom-select flex_center"
                      id="inputGroupSelect01"
                    >
                      <option selected>소속구분</option>
                      <option value="1">사용</option>
                      <option value="2">미사용</option>
                    </select>
                  </div>
                </div>
              </td>
              <td>
                <div class="input-group mb-12">
                  <div class="input-group-prepend">
                    <select
                      class="custom-select flex_center"
                      id="inputGroupSelect01"
                    >
                      <option selected>캠퍼스 선택</option>
                      <option value="1">사용</option>
                      <option value="2">미사용</option>
                    </select>
                  </div>
                </div>
              </td>
              <td>
                <div class="input-group mb-12">
                  <div class="input-group-prepend">
                    <select
                      class="custom-select flex_center"
                      id="inputGroupSelect01"
                    >
                      <option selected>타임 선택</option>
                      <option value="1">사용</option>
                      <option value="2">미사용</option>
                    </select>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>
                <div class="input-group mb-12">
                  <div class="input-group-prepend">
                    <select
                      class="custom-select flex_center"
                      id="inputGroupSelect01"
                    >
                      <option selected>관리구분</option>
                      <option value="1">사용</option>
                      <option value="2">미사용</option>
                    </select>
                  </div>
                </div>
              </td>
              <td>
                <div class="input-group mb-12">
                  <div class="input-group-prepend">
                    <select
                      class="custom-select flex_center"
                      id="inputGroupSelect01"
                    >
                      <option selected>지역 선택</option>
                      <option value="1">사용</option>
                      <option value="2">미사용</option>
                    </select>
                  </div>
                </div>
              </td>
              <td>
                <div class="input-group mb-12">
                  <div class="input-group-prepend">
                    <select
                      class="custom-select flex_center"
                      id="inputGroupSelect01"
                    >
                      <option selected>사용승인</option>
                      <option value="1">사용</option>
                      <option value="2">미사용</option>
                    </select>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>날짜검색</td>
              <td>
                <div class="input-group mb-12">
                  <div class="input-group-prepend">
                    <select
                      class="custom-select flex_center"
                      id="inputGroupSelect01"
                    >
                      <option selected>검색값 선택</option>
                      <option value="1">사용</option>
                      <option value="2">미사용</option>
                    </select>
                  </div>
                </div>
              </td>
              <td>
                <div class="input-group mb-12">
                  <div class="input-group-prepend">
                    <input type="date" class="input_text" />
                  </div>
                </div>
              </td>
              <td>
                <div class="input-group mb-12">
                  <div class="input-group-prepend">
                    <input type="date" class="input_text" />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>키워드검색</td>
              <td>
                <div class="input-group mb-12">
                  <div class="input-group-prepend">
                    <select
                      class="custom-select flex_center"
                      id="inputGroupSelect01"
                    >
                      <option selected>검색값 선택</option>
                      <option value="1">사용</option>
                      <option value="2">미사용</option>
                    </select>
                  </div>
                </div>
              </td>
              <td colspan="2">
                <div class="input-group mb-12">
                  <div class="input-group-prepend">
                    <input type="text" class="input_text" />
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="flex_center">
          <button class="btn btn-secondary">조회</button>
          <button
            class="btn btn-danger"
            data-toggle="modal"
            data-target=".bd-example-modal-lg"
          >
            신규등록
          </button>
          <button class="btn btn-success">엑셀등록</button>
        </div>
        <div style="float: right; padding-bottom: 10px">
          <button class="btn btn-secondary">메세지 발송</button>
        </div>
        <table class="table">
          <thead>
            <tr>
              <th scope="col">체크</th>
              <th scope="col">No</th>
              <th scope="col">타입/본부</th>
              <th scope="col">캠퍼스명</th>
              <th scope="col">대표자</th>
              <th scope="col">연락처</th>
              <th scope="col">등록ID수</th>
              <th scope="col">교사</th>
              <th scope="col">클래스</th>
              <th scope="col">ID단가</th>
              <th scope="col">계약시작일</th>
              <th scope="col">계약종료일</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><input type="checkbox" name="xxx" value="yyy" checked /></td>
              <td>1</td>
              <td>A/본사</td>
              <td>사당제일</td>
              <td>유란희</td>
              <td>010-0000-0000</td>
              <td>150</td>
              <td>3</td>
              <td>9</td>
              <td>40,000</td>
              <td>23-01-22</td>
              <td>23-02-22</td>

              <div
                class="modal fade bd-example-modal-lg"
                tabindex="-1"
                role="dialog"
                aria-labelledby="myLargeModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-lg">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="exampleModalLongTitle">
                        관리자 등록
                      </h5>
                      <button type="button" class="btn btn-danger btn-sm">
                        로그인
                      </button>
                    </div>
                    <div class="modal-body">
                      관리자일경우
                      <table class="table">
                        <tbody>
                          <tr>
                            <td class="th_bg">관리자코드</td>
                            <td>자동생성</td>
                            <td class="th_bg">사용여부</td>
                            <td>
                              <div class="input-group mb-12">
                                <div class="input-group-prepend">
                                  <select
                                    class="custom-select flex_center"
                                    id="inputGroupSelect01"
                                  >
                                    <option selected>선택</option>
                                    <option value="1">사용</option>
                                    <option value="2">미사용</option>
                                  </select>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="th_bg">소속구분</td>
                            <td>
                              <div class="input-group mb-12">
                                <div class="input-group-prepend">
                                  <select class="custom-select flex_center">
                                    <option selected>본사</option>
                                    <option value="1">학원</option>
                                    <option value="2">학교</option>
                                    <option value="2">킨더</option>
                                  </select>
                                </div>
                              </div>
                            </td>
                            <td class="th_bg">관리구분</td>
                            <td>
                              <div class="input-group mb-12">
                                <div class="input-group-prepend">
                                  <select
                                    class="custom-select flex_center"
                                    id="inputGroupSelect01"
                                  >
                                    <option selected>본사관리자</option>
                                    <option value="1">지사관리자</option>
                                    <option value="2">교육기관관리자</option>
                                  </select>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <table class="table">
                        <tbody>
                          <tr>
                            <td class="th_bg">아이디</td>
                            <td>kimdm</td>
                            <td class="th_bg">비밀번호</td>
                            <td>******</td>
                          </tr>
                          <tr>
                            <td class="th_bg">이름</td>
                            <td>김대만</td>
                            <td class="th_bg">연락처</td>
                            <td>010-3349-1471</td>
                          </tr>
                          <tr>
                            <td class="th_bg">ID시작일</td>
                            <td>2022-10-10</td>
                            <td class="th_bg">ID종료</td>
                            <td>2023-10-10</td>
                          </tr>
                          <tr>
                            <td class="th_bg">미국학교ID</td>
                            <td>kimdm@ubesta.co.kr</td>
                            <td class="th_bg">미국학교PW</td>
                            <td>*****</td>
                          </tr>
                          <tr>
                            <td class="th_bg">비고</td>
                            <td colspan="3">비고내용</td>
                          </tr>
                        </tbody>
                      </table>

                      학원-본부장일 경우
                      <table class="table">
                        <tbody>
                          <tr>
                            <td class="th_bg">관리자코드</td>
                            <td>자동생성</td>
                            <td class="th_bg">사용여부</td>
                            <td>
                              <div class="input-group mb-12">
                                <div class="input-group-prepend">
                                  <select
                                    class="custom-select flex_center"
                                    id="inputGroupSelect01"
                                  >
                                    <option selected>선택</option>
                                    <option value="1">사용</option>
                                    <option value="2">미사용</option>
                                  </select>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="th_bg">소속구분</td>
                            <td>
                              <div class="input-group mb-12">
                                <div class="input-group-prepend">
                                  <select
                                    name="select"
                                    class="custom-select flex_center"
                                  >
                                    <option selected>본사</option>
                                    <option value="1">학원</option>
                                    <option value="2">학교</option>
                                    <option value="2">킨더</option>
                                  </select>
                                </div>
                              </div>
                            </td>
                            <td class="th_bg">관리구분</td>
                            <td>
                              <div class="input-group mb-12">
                                <div class="input-group-prepend">
                                  <select
                                    name="inputGroupSelect"
                                    class="custom-select flex_center"
                                    id="inputGroupSelect"
                                  >
                                    <option selected>본사관리자</option>
                                    <option value="1">지사관리자</option>
                                    <option value="2">교육기관관리자</option>
                                  </select>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="th_bg">계약시작일</td>
                            <td>
                              <div class="input-group mb-12">
                                <div class="input-group-prepend">
                                  <input type="date" />
                                </div>
                              </div>
                            </td>
                            <td class="th_bg">계약종료일</td>
                            <td>
                              <div class="input-group mb-12">
                                <div class="input-group-prepend">
                                  <input type="date" />
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <table class="table">
                        <tbody>
                          <tr>
                            <td class="th_bg">사업자등록번호</td>
                            <td>123-45-97877</td>
                            <td class="th_bg">이름</td>
                            <td>김태수</td>
                          </tr>
                          <tr>
                            <td class="th_bg">연락처</td>
                            <td>010-0000-0000</td>
                            <td class="th_bg">이111메일</td>
                            <td>dishae@naver.com</td>
                          </tr>
                          <tr>
                            <td class="th_bg">주 소</td>
                            <td colspan="3">경기도 안양시 블라</td>
                          </tr>
                          <tr>
                            <td class="th_bg">은행</td>
                            <td>우리은행</td>
                            <td class="th_bg">예금주</td>
                            <td>김태수</td>
                          </tr>
                          <tr>
                            <td class="th_bg">계좌번호</td>
                            <td colspan="3">1002-95-2124567</td>
                          </tr>
                          <tr>
                            <td class="th_bg">미국ID</td>
                            <td>kidm@ubesta.co.kr</td>
                            <td class="th_bg">미국PW</td>
                            <td>*******</td>
                          </tr>
                          <tr>
                            <td class="th_bg">비고</td>
                            <td colspan="3">하...내용이 너무 많다</td>
                          </tr>
                        </tbody>
                      </table>

                      학원-대표자일 경우
                      <table class="table">
                        <tbody>
                          <tr>
                            <td class="th_bg">관리자코드</td>
                            <td>자동생성</td>
                            <td class="th_bg">사용여부</td>
                            <td>
                              <div class="input-group mb-12">
                                <div class="input-group-prepend">
                                  <select
                                    class="custom-select flex_center"
                                    id="inputGroupSelect01"
                                  >
                                    <option selected>선택</option>
                                    <option value="1">사용</option>
                                    <option value="2">미사용</option>
                                  </select>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="th_bg">소속구분</td>
                            <td>
                              <div class="input-group mb-12">
                                <div class="input-group-prepend">
                                  <select
                                    name="select"
                                    class="custom-select flex_center"
                                  >
                                    <option selected>본사</option>
                                    <option value="1">학원</option>
                                    <option value="2">학교</option>
                                    <option value="2">킨더</option>
                                  </select>
                                </div>
                              </div>
                            </td>
                            <td class="th_bg">관리구분</td>
                            <td>
                              <div class="input-group mb-12">
                                <div class="input-group-prepend">
                                  <select
                                    name="inputGroupSelect"
                                    class="custom-select flex_center"
                                    id="inputGroupSelect"
                                  >
                                    <option selected>본사관리자</option>
                                    <option value="1">지사관리자</option>
                                    <option value="2">교육기관관리자</option>
                                  </select>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="th_bg">계약시작일</td>
                            <td>
                              <div class="input-group mb-12">
                                <div class="input-group-prepend">
                                  <input type="date" />
                                </div>
                              </div>
                            </td>
                            <td class="th_bg">계약종료일</td>
                            <td>
                              <div class="input-group mb-12">
                                <div class="input-group-prepend">
                                  <input type="date" />
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="th_bg">아이디 비용</td>
                            <td>ㅇㄹㅇㄹㅇ</td>
                            <td class="th_bg" rowspan="2">서비스품목</td>
                            <td>
                              <label>
                                <input
                                  type="radio"
                                  name="RadioGroup1"
                                  value="북클럽"
                                  id="RadioGroup1_0"
                                />
                                북클럽[종료:22-01-20]</label
                              >
                            </td>
                          </tr>
                          <tr>
                            <td class="th_bg">초도물품</td>
                            <td>
                              <select
                                name="inputGroupSelect"
                                class=""
                                id="inputGroupSelect"
                              >
                                <option selected>ALL</option></select
                              ><input type="date" />
                            </td>

                            <td>
                              <label>
                                <input
                                  type="radio"
                                  name="RadioGroup1"
                                  value="보카조아"
                                  id="RadioGroup1_1"
                                />
                                보카조아[종료:22-01-20]</label
                              >
                            </td>
                          </tr>
                          <tr>
                            <td class="th_bg">
                              상품적용<button
                                class="btn btn-danger btn-sm"
                                data-toggle="modal"
                                data-target="#exampleModal"
                              >
                                추가
                              </button>

                              <!-- Modal -->
                              <div
                                class="modal fade"
                                id="exampleModal"
                                tabindex="-1"
                                role="dialog"
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                              >
                                <div class="modal-dialog" role="document">
                                  <div class="modal-content">
                                    <div class="modal-header">
                                      <h5
                                        class="modal-title"
                                        id="exampleModalLabel"
                                      >
                                        Modal title
                                      </h5>
                                    </div>
                                    <div class="modal-body">
                                      <p class="mb-0">
                                        Lorem Ipsum has been the industry's
                                        standard dummy text ever since the
                                        1500s, when an unknown printer took a
                                        galley of type and scrambled.
                                      </p>
                                    </div>
                                    <div class="modal-footer">
                                      <button
                                        type="button"
                                        class="btn btn-secondary"
                                        data-dismiss="modal"
                                      >
                                        Close
                                      </button>
                                      <button
                                        type="button"
                                        class="btn btn-primary"
                                      >
                                        Save changes
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td colspan="3">p123,p124</td>
                          </tr>
                        </tbody>
                      </table>

                      <table class="table">
                        <tbody>
                          <tr>
                            <td class="th_bg">사업자등록번호</td>
                            <td>123-45-97877</td>
                            <td class="th_bg">이름</td>
                            <td>김태수</td>
                          </tr>
                          <tr>
                            <td class="th_bg">연락처</td>
                            <td>010-0000-0000</td>
                            <td class="th_bg">이메일</td>
                            <td>dishae@naver.com</td>
                          </tr>
                          <tr>
                            <td class="th_bg">주 소</td>
                            <td colspan="3">경기도 안양시 블라</td>
                          </tr>
                          <tr>
                            <td class="th_bg">은행</td>
                            <td>우리은행</td>
                            <td class="th_bg">예금주</td>
                            <td>김태수</td>
                          </tr>
                          <tr>
                            <td class="th_bg">계좌번호</td>
                            <td colspan="3">1002-95-2124567</td>
                          </tr>
                          <tr>
                            <td class="th_bg">미국ID</td>
                            <td>kidm@ubesta.co.kr</td>
                            <td class="th_bg">미국PW</td>
                            <td>*******</td>
                          </tr>
                          <tr>
                            <td class="th_bg">비고</td>
                            <td colspan="3">하...내용이 너무 많다</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="modal-footer flex_center">
                      <button type="button" class="btn btn-primary">
                        등록
                      </button>
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                      >
                        닫기
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </tr>
            <tr v-for="record in records" v-bind:key="record.id">
              <td scope="row">{{ record.id }}</td>
              <td scope="row">{{ record.id }}</td>
              <td>{{ record.username }}</td>
              <td>{{ record.username }}</td>
              <td>{{ record.username }}</td>
              <td>{{ record.business }}</td>
              <td>{{ record.name }}</td>
              <td>{{ record.createdAt }}</td>
              <td>{{ record.lastLoginAt }}</td>
              <td>
                <button class="btn btn-primary">수정</button>
                <button class="btn btn-danger">삭제</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="card-body">
    <h1 class="mt-4"></h1>

    {{ this.records }}
  </div>
</template>

<script>
// @ is an alias to /src

import Tree from "../components/Tree";
import axios from "axios";
export default {
  name: "Home",
  components: {
    Tree,
  },
  mounted() {
    this.search();
  },
  methods: {
    search() {
      axios
        .get("/businesses/" + this.$route.params.id + "/admins")
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            this.records = response.data.result;
          }
        });
    },
  },
  data() {
    return {
      records: [],
    };
  },
};
</script>
